import type { ELanguage } from '../languageHelper';

import { type ITextBase, oftenUsedTranslations } from './oftenUsed';

export interface IEmployeeDevelopmentTexts extends ITextBase {
    noSuggestedSkills: string;
    showAllSuggestedSkills: string;
    newGoalDialogCertificateSelect: string;
    goal: string;
    competenceGoal: string;
    editGoalTitle: string;
    goalName: string;
    goalsHint: string;
    goalsTitle: string;
    goalDate: string;
    newGoalDialogSkillPleaceCheck: string;
    newGoalDialogSkillHint: string;
    newGoalDialogSkillSelect: string;
    newGoalDialogTitle: string;
    skillFastSelect: string;
    saving: string;
    errorMapSkill: string;
    wantedCompetencesHint: string;
    wantedSkillsHint: string;
    wantedSkillsTitle: string;
    hideSkillSuggestion: string;
    suggestedSkills: string;
    confirmHideGoal: string;
    planningCardDescription: string;
    untilDate: string;
    learnProgress: string;
    wantedCompetencesTitle: string;
    planningCardTitle: string;
    mySkills: string;
    manageSkills: string;
    total: string;
    expert: string;
    topSkills: string;
    manageRoles: string;
    active: string;
    currentRoles: string;
    currentProjects: string;
    goals: string;
    manageGoals: string;
    priority: string;
    currentGoals: string;
    manageCertificates: string;
    viewAll: string;
    yourLearningStatus: string;
    inProgress: string;
    nextTraining: string;
    expiringSoon: string;
    yourSuperPowers: string;
    strongestSkills: string;
    hardSkills: string;
    softSkills: string;
    languages: string;
    industryKnowledge: string;
    noSkillsInCategory: string;
    skillChecker: string;
    selectSkillsToCompare: string;
    selectSkillToSeeComparison: string;
    detailedAnalysis: string;
    you: string;
    teamAverage: string;
    companyAverage: string;
    level: string;
    youLeadInThisSkill: string;
    youAreTopInThisSkill: string;
    youAreAboveAverage: string;
    youAreAtAverage: string;
    youCanGrowHere: string;
}
type ILangData = {
    [lang in ELanguage]: IEmployeeDevelopmentTexts;
};
export const employeedevelopmentTexts: ILangData = {
    th: {
        noSuggestedSkills: 'ไม่มีทักษะที่แนะนำ',
        showAllSuggestedSkills: 'แสดงทักษะที่แนะนำทั้งหมด',
        newGoalDialogCertificateSelect: 'เลือกใบรับรองที่คุณต้องการที่จะได้รับ',
        goal: 'เป้าหมาย',
        competenceGoal: 'เป้าหมายความสามารถ',
        editGoalTitle: 'แก้ไขเป้าหมาย',
        goalName: 'ชื่อเป้าหมาย',
        goalsTitle: 'เป้าหมายการเรียนรู้ของคุณ',
        goalsHint: 'ด้านล่างนี้คือเป้าหมายที่คุณตั้งไว้ คุณสามารถติดตามความคืบหน้าของแต่ละเป้าหมาย และสามารถเสร็จสิ้นหรือลบได้ตามความจำเป็น',
        goalDate: 'วันที่เป้าหมาย',
        newGoalDialogSkillPleaceCheck: 'โปรดตรวจสอบทักษะและระดับของคุณก่อนที่คุณจะดำเนินการต่อ',
        newGoalDialogSkillHint: 'เมื่อคุณได้เพิ่มทักษะที่ต้องการทั้งหมดแล้ว คลิกที่ "ดำเนินการต่อ" เพื่อตั้งวันที่เป้าหมาย',
        newGoalDialogSkillSelect:
            'เลือกทักษะจากรายการ และกำหนดระดับที่คุณต้องการจะถึง จากนั้นคลิกที่สัญลักษณ์ "+" เพื่อเพิ่มการเลือกลงในเป้าหมายของคุณ คุณสามารถเพิ่มทักษะได้ตามที่คุณต้องการ',
        newGoalDialogTitle: 'ตั้งเป้าหมายใหม่',
        skillFastSelect: 'การเลือกอย่างรวดเร็ว',
        errorMapSkill: 'ไม่สามารถสร้างการเชื่อมโยงทักษะ:',
        saving: 'กำลังบันทึก...',
        wantedSkillsHint:
            'ความสามารถที่ต้องการเป็นความสามารถเฉพาะที่คุณตั้งใจจะเรียนรู้หรือปรับปรุง ที่นี่คุณจะเห็นการผสมผสานระหว่างเป้าหมายทักษะที่ตั้งไว้โดยตรงและทักษะที่มาจากเป้าหมายความสามารถของคุณ มันช่วยให้คุณรักษาภาพรวมของการเดินทางการเรียนรู้ของคุณ เน้นที่ทักษะที่คุณเรียนรู้เสร็จสิ้นแล้วและที่ยังคงอยู่ในรายการของคุณ',
        wantedCompetencesHint:
            "ส่วน 'ความสามารถที่ต้องการ' แสดงถึงบริเวณหลักที่คุณต้องการพัฒนาต่อ แต่ละความสามารถสามารถรวมถึงทักษะหลายๆ ทักษะ ที่นี่คุณสามารถดูความสามารถที่คุณได้เลือก ติดตามความก้าวหน้าในการเรียนรู้ของคุณ และระบุทักษะเฉพาะที่คุณยังต้องเรียนรู้เพื่อที่จะเชี่ยวชาญในความสามารถนั้นๆ อย่างสมบูรณ์",
        wantedSkillsTitle: 'ทักษะที่ต้องการ',
        hideSkillSuggestion: 'ซ่อนคำแนะนำทักษะ',
        suggestedSkills: 'ทักษะที่แนะนำ',
        confirmHideGoal: 'ยืนยันเป้าหมายและซ่อน',
        planningCardDescription:
            'ตั้งเป้าหมายเพื่อขยายความสามารถและความสามารถของคุณ ติดตามความก้าวหน้าของคุณและสามารถบรรลุแสงแถบการทำงานของคุณ',
        untilDate: 'วันที่เป้าหมาย',
        learnProgress: 'ความคืบหน้าในการเรียนรู้',
        wantedCompetencesTitle: 'ความสามารถที่ต้องการ',
        planningCardTitle: 'เป้าหมายในการศึกษาต่อ',
        mySkills: 'ทักษะของฉัน',
        manageSkills: 'จัดการทักษะ',
        total: 'ทั้งหมด',
        expert: 'ผู้เชี่ยวชาญ',
        topSkills: 'ทักษะชั้นนำ',
        manageRoles: 'จัดการบทบาท',
        active: 'ใช้งาน',
        currentRoles: 'บทบาทปัจจุบัน',
        currentProjects: 'โครงการปัจจุบัน',
        goals: 'เป้าหมาย',
        manageGoals: 'จัดการเป้าหมาย',
        priority: 'ลำดับความสำคัญ',
        currentGoals: 'เป้าหมายปัจจุบัน',
        manageCertificates: 'จัดการใบรับรอง',
        viewAll: 'ดูทั้งหมด',
        yourLearningStatus: 'สถานะการเรียนรู้ของคุณ',
        inProgress: 'กำลังดำเนินการ',
        nextTraining: 'การฝึกอบรมครั้งต่อไป',
        expiringSoon: 'จะหมดอายุเร็วๆ นี้',
        yourSuperPowers: 'พลังพิเศษของคุณ',
        strongestSkills: 'ทักษะที่แข็งแกร่งที่สุด (ระดับ 4+) ตามหมวดหมู่',
        hardSkills: 'ทักษะเทคนิค',
        softSkills: 'ทักษะนุ่ม',
        languages: 'ภาษา',
        industryKnowledge: 'ความรู้ด้านอุตสาหกรรม',
        noSkillsInCategory: 'ยังไม่มีทักษะในหมวดหมู่นี้',
        skillChecker: 'ตัวตรวจสอบทักษะ',
        selectSkillsToCompare: 'เลือกทักษะและเปรียบเทียบกับเพื่อนร่วมงาน',
        selectSkillToSeeComparison: 'เลือกทักษะเพื่อดูการเปรียบเทียบ',
        detailedAnalysis: 'แสดงการวิเคราะห์โดยละเอียด',
        you: 'คุณ',
        teamAverage: 'ค่าเฉลี่ยทีม',
        companyAverage: 'ค่าเฉลี่ยบริษัท',
        level: 'ระดับ',
        youLeadInThisSkill: 'คุณนำในทักษะนี้',
        youAreTopInThisSkill: 'คุณเป็นผู้นำในทักษะนี้',
        youAreAboveAverage: 'คุณอยู่เหนือค่าเฉลี่ย',
        youAreAtAverage: 'คุณอยู่ที่ค่าเฉลี่ย',
        youCanGrowHere: 'คุณสามารถเติบโตได้ที่นี่',
        oftenUsed: oftenUsedTranslations.th,
    },
    en: {
        noSuggestedSkills: 'No suggested skills',
        showAllSuggestedSkills: 'Show all suggested skills',
        newGoalDialogCertificateSelect: 'Choose certifications you want to achieve.',
        goal: 'Goal',
        competenceGoal: 'Competence goal',
        editGoalTitle: 'Edit goal',
        goalName: 'Goal Name',
        goalsTitle: 'Your learning goals',
        goalsHint:
            'Below are the goals that you have set. You can track the progress of each goal and complete or delete as necessary.',
        goalDate: 'Goal Date',
        newGoalDialogSkillPleaceCheck: 'Please check your skills and levels before you proceed.',
        newGoalDialogSkillHint: 'Once you have added all desired skills, click on "Next" to set the target date.',
        newGoalDialogSkillSelect:
            'Select a skill from the list and determine the level you want to reach. Then click on the "+" symbol to add the selection to your goal. You can add as many skills as you want.',
        newGoalDialogTitle: 'Set new goal',
        skillFastSelect: 'Fast select',
        errorMapSkill: 'Skill link could not be created:',
        saving: 'Saving...',
        wantedSkillsHint:
            "Wanted skills refer to those specific abilities you've set out to learn or enhance. Here, you'll see a blend of directly set skill goals and the skills that stem from your competency objectives. It helps you maintain an overview of your learning journey, highlighting which skills you've already mastered and which remain on your list.",
        wantedCompetencesHint:
            "The 'Wanted Competencies' section displays the overarching areas you wish to develop further. Each of these competencies can encompass multiple skills. Here, you can view your selected competencies, track your learning progress, and identify the specific skills you still need to acquire to fully master a given competency.",
        wantedSkillsTitle: 'Desired Skills',
        hideSkillSuggestion: 'Hide skill suggestion',
        suggestedSkills: 'Suggested Skills',
        confirmHideGoal: 'Confirm goal & hide',
        planningCardDescription:
            'Set goals to extend your skills and competencies. Track your progress and achieve your professional milestones.',
        untilDate: 'Target date',
        learnProgress: 'Learning progress',
        wantedCompetencesTitle: 'Desired competences',
        planningCardTitle: 'Further Education Goals',
        mySkills: 'My Skills',
        manageSkills: 'Manage Skills',
        total: 'Total',
        expert: 'Expert',
        topSkills: 'Top Skills',
        manageRoles: 'Manage Roles',
        active: 'Active',
        currentRoles: 'Current Roles',
        currentProjects: 'Current Projects',
        goals: 'Goals',
        manageGoals: 'Manage Goals',
        priority: 'Priority',
        currentGoals: 'Current Goals',
        manageCertificates: 'Manage Certificates',
        viewAll: 'View All',
        yourLearningStatus: 'Your Learning Status',
        inProgress: 'In Progress',
        nextTraining: 'Next Training',
        expiringSoon: 'Expiring Soon',
        yourSuperPowers: 'Your Super Powers',
        strongestSkills: 'Your strongest skills (Level 4+) by categories',
        hardSkills: 'Hard Skills',
        softSkills: 'Soft Skills',
        languages: 'Languages',
        industryKnowledge: 'Industry Knowledge',
        noSkillsInCategory: 'No skills in this category yet',
        skillChecker: 'Skill Checker',
        selectSkillsToCompare: 'Select a skill and compare yourself with peers',
        selectSkillToSeeComparison: 'Select a skill to see the comparison',
        detailedAnalysis: 'Show detailed analysis',
        you: 'You',
        teamAverage: 'Team Avg',
        companyAverage: 'Company Avg',
        level: 'Level',
        youLeadInThisSkill: 'You lead in this skill',
        youAreTopInThisSkill: 'You are top in this skill',
        youAreAboveAverage: 'You are above average',
        youAreAtAverage: 'You are at average',
        youCanGrowHere: 'Here you can still grow',
        oftenUsed: oftenUsedTranslations.en,
    },
    de: {
        oftenUsed: oftenUsedTranslations.de,
        planningCardTitle: 'Weiterbildungsziele',
        wantedCompetencesTitle: 'Wunschkompetenzen',
        learnProgress: 'Lernfortschritt',
        untilDate: 'Ziel-Datum',
        planningCardDescription:
            'Setz dir Ziele, um deine Fähigkeiten und Kompetenzen zu erweitern. Verfolge deinen Fortschritt und erreiche deine beruflichen Meilensteine.',
        confirmHideGoal: 'Ziel bestätigen & ausblenden',
        suggestedSkills: 'Vorgeschlagene Fähigkeiten',
        hideSkillSuggestion: 'Fähigkeitsvorschlag ausblenden',
        wantedSkillsTitle: 'Wunschfähigkeiten',
        wantedSkillsHint:
            'Wunschfähigkeiten sind jene speziellen Skills, die du dir vorgenommen hast zu erlernen oder zu verbessern. Hier siehst du eine Kombination aus direkt gesetzten Fähigkeitszielen und den Fähigkeiten, die sich aus deinen Kompetenzzielen ergeben. Es unterstützt dich dabei, den Überblick über deinen Lernprozess zu behalten und zeigt auf, welche Fähigkeiten du bereits gemeistert hast und welche noch auf deiner Liste stehen.',
        wantedCompetencesHint:
            "Der Bereich 'Wunschkompetenzen' zeigt die übergeordneten Bereiche an, in denen du dich weiterentwickeln möchtest. Jede dieser Kompetenzen kann mehrere Fähigkeiten beinhalten. Du kannst hier deine ausgewählten Kompetenzen einsehen, deinen Lernfortschritt nachvollziehen und erkennen, welche spezifischen Fähigkeiten du noch erwerben musst, um die jeweilige Kompetenz vollständig zu meistern.",
        saving: 'Wird gespeichert...',
        errorMapSkill: 'Fähigkeitsverknüpfung konnte nicht erstellt werden:',
        skillFastSelect: 'Schnellauswahl',
        newGoalDialogTitle: 'Neues Ziel setzen',
        newGoalDialogSkillSelect:
            'Wähle eine Fähigkeit aus der Liste aus und bestimme die Stufe, die du erreichen möchtest. Klicke anschließend auf das "+"-Symbol, um die Auswahl zu deinem Ziel hinzuzufügen. Du kannst beliebig viele Fähigkeiten hinzufügen.',
        newGoalDialogSkillHint:
            'Wenn du alle gewünschten Fähigkeiten hinzugefügt hast, klicke auf "Weiter", um das Zieldatum festzulegen.',
        newGoalDialogSkillPleaceCheck: 'Bitte überprüfe deine Fähigkeiten und Stufen, bevor du fortfährst.',
        goalDate: 'Ziel-Datum',
        goalsHint:
            'Unten siehst du die Ziele, die du dir gesetzt hast. Du kannst den Fortschritt jedes Ziels verfolgen und es nach Bedarf abschließen oder löschen.',
        goalsTitle: 'Deine Lernziele',
        goalName: 'Ziel-Name',
        editGoalTitle: 'Ziel bearbeiten',
        competenceGoal: 'Kompetenz Ziel',
        goal: 'Ziel',
        newGoalDialogCertificateSelect: 'Wähle Zertifizierungen aus die du erlangen möchtest.',
        showAllSuggestedSkills: 'Alle vorgeschlagenen Fähigkeiten anzeigen',
        noSuggestedSkills: 'Keine vorgeschlagenen Fähigkeiten',
        mySkills: 'Meine Skills',
        manageSkills: 'Skills verwalten',
        total: 'Gesamt',
        expert: 'Expert',
        topSkills: 'Top Skills',
        manageRoles: 'Rollen verwalten',
        active: 'Aktiv',
        currentRoles: 'Aktuelle Rollen',
        currentProjects: 'Aktuelle Projekte',
        goals: 'Ziele',
        manageGoals: 'Ziele verwalten',
        priority: 'Priorität',
        currentGoals: 'Aktuelle Ziele',
        manageCertificates: 'Zertifikate verwalten',
        viewAll: 'Alle anzeigen',
        yourLearningStatus: 'Dein Lernstatus',
        inProgress: 'In Progress',
        nextTraining: 'Nächste Weiterbildung',
        expiringSoon: 'Bald ablaufend',
        yourSuperPowers: 'Deine SuperPowers',
        strongestSkills: 'Deine stärksten Skills (Level 4+) nach Kategorien',
        hardSkills: 'Hard Skills',
        softSkills: 'Soft Skills',
        languages: 'Sprachen',
        industryKnowledge: 'Branchen-Know-how',
        noSkillsInCategory: 'Noch keine Skills in dieser Kategorie',
        skillChecker: 'Skill Checker',
        selectSkillsToCompare: 'Wähle einen Skill und vergleiche dich mit Peers',
        selectSkillToSeeComparison: 'Wähle einen Skill aus, um den Vergleich zu sehen',
        detailedAnalysis: 'Detaillierte Analyse anzeigen',
        you: 'Du',
        teamAverage: 'Team Ø',
        companyAverage: 'Company Ø',
        level: 'Level',
        youLeadInThisSkill: 'Du führst in diesem Skill',
        youAreTopInThisSkill: 'Du bist Spitze in diesem Skill',
        youAreAboveAverage: 'Du liegst über dem Durchschnitt',
        youAreAtAverage: 'Du liegst im Durchschnitt',
        youCanGrowHere: 'Hier kannst du noch wachsen',
    },
};
